import Link from 'next/link';
import React from 'react';
import { careers_positions_data } from '../../data/careers_positions_data';

const Positions = ({ positionsList = null }) => {
	const position_list = (positionsList?.length > 0) ? positionsList.map((e) => {
		return {
			post_id: e.id,
			post_title: e?.attributes?.post_title,
			post_title_2: e?.attributes?.post_title_2,
			post_short_description: e?.attributes?.post_short_description,
			post_slug: e?.attributes?.post_slug
		};
	}) : careers_positions_data ?? [];

	return (
		<div>
			{/* <!-- Positions --> */}
			<section className="relative py-24 dark:bg-jacarta-900">
				<div className="container">
					<div className="grid gap-7 md:grid-cols-3">
						{position_list.map((item) => {
							const { post_id, post_title, post_title_2, post_short_description, post_slug } = item;
							return (
								<div
									key={post_id}
									className="rounded-2.5xl border border-jacarta-100 bg-white p-12 text-center transition-shadow hover:shadow-xl dark:border-jacarta-600 dark:bg-[#09092C]"
								>
									<h3 className="mb-1 font-display text-lg text-jacarta-700 dark:text-white">
										{post_title}
									</h3>
									<span className="mb-4 block text-xs text-jacarta-400 dark:text-jacarta-300">
										{post_title_2}
									</span>
									<p className="mb-8 dark:text-jacarta-300">{post_short_description}</p>
									{/* <Link href={'/contact'} legacyBehavior> */}
									<Link href={`/careers/${post_slug}`} legacyBehavior>
										<a className="text-sm font-bold text-primary">Apply Now</a>
									</Link>
								</div>
							);
						})}
					</div>
					<div className="mx-auto mt-20 max-w-md rounded-2lg py-5 px-10 text-center sm:flex sm:items-center sm:text-left">
						<h4 className="mb-2 text-center font-display font-semibold text-jacarta-700 dark:text-white sm:mb-0 sm:text-left">
							Didn’t see your dream job?
						</h4>
						<Link href="/contact" legacyBehavior>
							<a className="ml-auto inline-block rounded-full bg-primary py-2.5 px-8 text-center text-sm font-semibold text-white transition-all hover:bg-accent-dark">
								<span>Get In Touch</span>
							</a>
						</Link>
					</div>
				</div>
			</section>
			{/* <!-- end positions --> */}
		</div>
	);
};

export default Positions;
